<template>
  <Layout :is-loading="isLoading">
    <div class="bloco">
      <HeaderPage
        :form-open="formOpen"
        :page-titles="pageTitles"
        hide-button="true"
      />
      <div>
        <b-table
          :items="obras"
          striped
          hover
          per-page="10"
          :current-page="currentPage"
          tbody-tr-class="class-row"
          :fields="fieldsObras"
          sort-by="nome"
          empty-text="Não há obras cadastradas."
          @row-clicked="listLimits"
        />
        <b-pagination
          v-model="currentPage"
          size="md"
          :total-rows="rows"
          per-page="10"
        />
      </div>
      <b-modal
        v-model="openModalDelete"
        title="Aviso"
        title-class="font-18"
        @hide="cancelaDelete"
      >
        <p>Tem certeza que deseja excluir este registro?</p>
        <template v-slot:modal-footer>
          <b-button variant="light" @click="cancelaDelete">Não</b-button>
          <b-button variant="danger" @click="onDelete(idDelete)">Sim</b-button>
        </template>
      </b-modal>
      <b-modal v-model="modalOpenRegisters" size="xl" hide-footer>
        <template slot="modal-title">
          <h3>Quantidades Máximas Cadastradas</h3>
          <p class="obra-details">OBRA: {{ obraSelecionada.nome }} </p>
          <p class="obra-details"
            >*OBS: É importante observar que a quantidade utilizada pode exceder
            as limitações especificadas, caso o usuário responsável pela
            conclusão tenha permissões para aprovações excedentes.</p
          >
        </template>
        <div class="header-button_register">
          <b-button @click="handleRegister(id)">Novo Cadastro</b-button>
        </div>
        <b-table
          :items="quantityItems"
          :fields="quantityFields"
          :empty-text="loading ? 'Carregando...' : 'Não há quantidades máximas cadastradas para essa obra.'"
          show-empty
        >
          <template v-slot:cell(actions)="row">
            <div class="row-buttons">
              <b-button
                size="sm"
                variant="outline-primary"
                class="icon-button"
                @click="edit(row.item)"
              >
                <feather type="edit" />
              </b-button>
              <b-button
                size="sm"
                variant="outline-danger"
                class="icon-button"
                @click="modalDelete(row.item)"
              >
                <feather type="trash" />
              </b-button>
            </div>
          </template>
        </b-table>
      </b-modal>
      <b-modal v-model="modalRegister" hide-footer @hide="clear">
        <template slot="modal-title">
          <h3>Registro de Quantidade Máxima</h3>
        </template>
        <form ref="form" @submit.stop.prevent="salva">
          <b-form-group :state="errors.insumo" label="Pesquisar insumo">
            <b-input
              v-model="requisicao.codigoInsumo"
              type="number"
              placeholder="000.0"
              min="1"
              :state="errors.insumo"
              required
              @change="carregaInsumo"
            />
            <b-form-invalid-feedback>
              Insira um código de insumo válido.
            </b-form-invalid-feedback>
          </b-form-group>
          <b-form-group label="Insumo">
            <b-input
              v-model="insumo"
              type="text"
              placeholder="Pesquise um insumo"
              required
              disabled
            />
          </b-form-group>
          <b-form-group :state="errors.torre" label="Torre">
            <Multiselect
              v-model="requisicao.torre"
              label="text"
              :options="torres"
              track-by="text"
              placeholder="Selecione uma torre"
              selected-label="Selecionado"
              deselect-label="Remover"
              select-label="Adicionar"
            />
            <p
              v-if="submit && !requisicao.torre"
              id="torre-feedback"
              class="error"
            >
              Selecione uma torre.
            </p>
          </b-form-group>
          <b-form-group :state="errors.andar" label="Andar">
            <Multiselect
              v-model="requisicao.andar"
              label="text"
              :options="andares"
              track-by="text"
              placeholder="Selecione um andar"
              selected-label="Selecionado"
              deselect-label="Remover"
              select-label="Adicionar"
              :close-on-select="false"
              multiple
            />
            <!-- <b-form-select
              v-model="$v.requisicao.andar.$model"
              aria-placeholder="Selecione o(s) andar(es)"
              :state="errors.andar"
              :options="andares"
              aria-describedby="andar-feedback"
              required
              @change="errors.andar = null"
            /> -->
            <p
              v-if="submit && !requisicao.andar"
              id="andar-feedback"
              class="error"
            >
              Selecione um andar.
            </p>
          </b-form-group>
          <b-form-group
            label="Quantidade máxima do insumo"
            label-for="quantity-input"
            :state="errors.quantidade"
            invalid-feedback="Insira uma quantidade válida."
          >
            <b-input
              id="quantity-input"
              v-model="requisicao.quantidade"
              :state="errors.quantidade"
              type="number"
              min="1"
              placeholder="0"
              required
              @change="errors.quantidade = null"
            />
          </b-form-group>
          <div class="footer-form">
            <b-button @click="modalRegister = false">Cancelar</b-button>
            <b-button class="button-submit" @click="salva"> Salvar </b-button>
          </div>
        </form>
      </b-modal>
      <b-modal v-model="modalEdit" hide-footer @hide="clearEdit">
        <template slot="modal-title">
          <h3>Editar</h3>
        </template>
        <form>
          <b-form-group
            label="Quantidade máxima do insumo"
            label-for="quantity-input"
            :state="errors.quantidadeLimite"
            invalid-feedback="Insira uma quantidade válida."
          >
            <b-input
              v-if="itemEdit"
              id="quantity-input"
              v-model="itemEdit.quantidadeLimite"
              :state="errors.quantidadeLimite"
              type="number"
              min="1"
              placeholder="0"
              required
              @change="errors.quantidade = null"
            />
          </b-form-group>
          <div class="footer-form">
            <b-button @click="modalEdit = false" @hide="clear"
              >Cancelar</b-button
            >
            <b-button class="button-submit" @click="edita"> Salvar </b-button>
          </div>
        </form>
      </b-modal>
    </div>
  </Layout>
</template>

<script>
import Layout from '@layouts/main'
import { required } from 'vuelidate/lib/validators'
import HeaderPage from '@/src/components/register/header-page.vue'
import alertMixin from '@/src/mixins/alertMixin'
import serviceQuantidadeLimite from '../../../../services/serviceQuantidadeLimite'
import RequisicoesModel from '@/src/model/requisicoes.model'
import { mapState } from 'vuex'
import serviceObra from '@/src/services/serviceObra'
import InsumoService from '@/src/services/serviceInsumoObra'
import Multiselect from 'vue-multiselect'

export default {
  components: { Layout, HeaderPage, Multiselect },
  mixins: [alertMixin],
  data() {
    return {
      submit: false,
      item: {},
      itemEdit: {},
      errors: {
        insumo: null,
        torre: null,
        andar: null,
        quantidade: null,
        quantidadeLimite: null,
      },
      nameState: null,
      submittedNames: [],
      quantityItems: [],
      andares: [{ text: 'Selecione um Andar', value: null }],
      torres: [{ text: 'Selecione uma Torre', value: null }],
      quantityFields: [
        {
          key: 'insumo.codigo',
          label: 'Cod. Insumo',
          thStyle: { width: '120px' },
        },
        {
          key: 'insumo',
          label: 'Item',
          formatter: (value) => {
            if (value.descricaoPai) {
              return `${value.descricaoPai} - ${value.descricao}`
            }
            if (value.descricao_pai) {
              return `${value.descricao_pai} - ${value.descricao}`
            }
            if (value.insumo) {
              if (value.insumo.descricaoPai) {
                return `${value.insumo.descricaoPai} - ${value.insumo.descricao}`
              }
              if (value.insumo.descricao_pai) {
                return `${value.insumo.descricao_pai} - ${value.insumo.descricao}`
              }
            }
            if (value.descricao) {
              return value.descricao
            }
          },
        },
        {
          key: 'identificadorTorre',
          label: 'Torre',
          formatter: (value) => {
            try {
              const torre = this.torres.find((item) => item.value === value)

              return torre.text
            } catch (error) {
              return ''
            }
          },
          thStyle: { width: '130px' },
        },
        {
          key: 'identificadorAndar',
          label: 'Andar',
          formatter: (value) => {
            try {
              const andar = this.andares.find((item) => item.value === value)

              return andar.text
            } catch {
              return ''
            }
          },
          thStyle: { width: '80px' },
        },
        {
          key: 'quantidadeUtilizada',
          label: 'Qtd. Utilizada',
          thStyle: { width: '160px' },
        },
        {
          key: 'quantidadeLimite',
          label: 'Qtd. Máxima',
          thStyle: { width: '160px' },
        },
        {
          key: 'actions',
          label: 'Ações',
          thStyle: { width: '100px' },
        },
      ],
      modalRegister: false,
      modalOpenRegisters: false,
      obraSelecionada: {},
      registroSelecionado: {},
      openModalDelete: false,
      modalShow: false,
      fieldsObras: [
        {
          key: 'codigo',
          label: 'Código',
          sortable: true,
          thStyle: { width: '140px' },
        },
        {
          key: 'nome',
          label: 'Obra',
          sortable: true,
          formatter: (value) => {
            return value.toUpperCase()
          },
        },
        {
          key: 'torres.length',
          label: 'Torres',
          sortable: true,
          thStyle: { width: '180px' },
        },
      ],
      pageTitles: {
        title: 'Quantidade Máxima',
        subtitle: 'Cadastra quantidade máxima de insumos por andar',
      },
      isLoading: false,
      formOpen: false,
      loading: false,
      grupoFields: RequisicoesModel.grupoFields,
      requisicao: {
        codigoInsumo: '',
        insumo: {},
        torre: null,
        andar: null,
        quantidade: '',
      },
      requisicoes: [],
      obra: {},
      obras: [],
      idDelete: '',
      currentPage: 1,
      perPage: 10,
      rows: 0,
      modalEdit: false,
      tipo_conta: this.$attrs.user.user.tipo_conta,
      insumo: '',
    }
  },
  validations: {
    requisicao: {
      codigoInsumo: {
        required,
      },
      torre: {
        required,
      },
      andar: {
        required,
      },
      quantidade: {
        required,
      },
    },
    itemEdit: {
      quantidadeLimite: {
        required,
        min: (value) => value > 0 || 'Insira uma quantidade válida.',
      },
    },
  },
  computed: {
    ...mapState('auth', ['currentUser']),
  },
  async created() {
    await this.listaObras()
  },
  methods: {
    getValidation() {
      this.$v.$touch()
      if (this.$v.$invalid) {
        if (this.$v.requisicao.codigoInsumo.$error) {
          this.errors.insumo = false
        } else {
          if (this.requisicao.insumo) {
            this.errors.insumo = true
          } else {
            this.errors.insumo = false
          }
        }
        if (this.$v.requisicao.torre.$error) {
          this.errors.torre = false
        } else {
          this.errors.torre = true
        }
        if (this.$v.requisicao.andar.$error) {
          this.errors.andar = false
        } else {
          this.errors.andar = true
        }
        if (this.$v.requisicao.quantidade.$error) {
          this.errors.quantidade = false
        } else {
          this.errors.quantidade = true
        }
        return false
      }
      return true
    },
    getValidationEdit() {
      this.$v.$touch()
      if (this.$v.itemEdit.quantidadeLimite.$error) {
        this.errors.quantidadeLimite = false
      } else {
        this.errors.quantidadeLimite = true
        return false
      }
      return true
    },
    salva() {
      this.submit = true

      const andaresArr = []
      if (this.requisicao.andar) {
        this.requisicao.andar.forEach((andar) => {
          andaresArr.push(andar.value)
        })
      }

      if (
        !this.getValidation() &&
        this.torres.length > 0 &&
        this.andares.length > 0
      ) {
        serviceQuantidadeLimite
          .postQuantidadeLimite(
            andaresArr,
            this.requisicao.torre.value,
            this.obraSelecionada._id,
            this.requisicao.insumo._id,
            this.requisicao.quantidade
          )
          .then(() => {
            this.successMessage('Quantidade máxima cadastrada com sucesso')
            this.modalRegister = false
            this.quantityItems = []
            serviceQuantidadeLimite
              .getQuantidadeLimite(this.obraSelecionada._id)
              .then(
                (response) => {
                  this.quantityItems = response.data
                },
                (error) => {
                  this.errorMessage(error.response.data.error.message)
                }
              )
            this.clear()
            this.listaObras()
          })
          .catch((error) => {
            this.errorMessage(error.response.data.error.message)
          })
      }
    },
    edita() {
      if (!this.getValidationEdit()) {
        serviceQuantidadeLimite
          .patchQuantidadeLimite(
            this.itemEdit._id,
            this.itemEdit.quantidadeLimite
          )
          .then((response) => {
            this.quantityItems = []
            this.successMessage('Quantidade máxima editada com sucesso')
            this.modalEdit = false
            serviceQuantidadeLimite
              .getQuantidadeLimite(this.obraSelecionada._id)
              .then(
                (response) => {
                  this.quantityItems = response.data
                },
                (error) => {
                  this.errorMessage(error.response.data.error.message)
                }
              )
            this.clearEdit()
            this.clear()
          })
          .catch((error) => {
            console.error(error)
            this.errorMessage(error.response.data.error.message)
          })
      }
    },
    onDelete(id) {
      serviceQuantidadeLimite
        .deleteQuantidadeLimite(id)
        .then((_response) => {
          this.successMessage('Item apagado com sucesso.')
          this.openModalDelete = false
          this.quantityItems = []
          serviceQuantidadeLimite
            .getQuantidadeLimite(this.obraSelecionada._id)
            .then(
              (response) => {
                this.quantityItems = response.data
              },
              (error) => {
                this.errorMessage(error.response.data.error.message)
              }
            )
        })
        .catch((error) => {
          this.errorMessage(error.response.data.error.message)
        })
    },
    async carregaInsumo() {
      this.errors.insumo = null
      let filial = null
      let empresa = null

      if (this.obraSelecionada.filial._id) {
        filial = this.obraSelecionada.filial._id
      }

      if (this.obraSelecionada.empresa) {
        empresa = this.obraSelecionada.empresa
      }

      try {
        this.insumo = 'Carregando...'
        const response = await InsumoService.buscaCod(
          this.requisicao.codigoInsumo,
          empresa,
          filial
        )
        console.log(response.data.data)
        this.requisicao.insumo = response.data.data
        this.insumo = response.data.data.descricao_pai
          ? `${response.data.data.descricao_pai} - ${response.data.data.descricao}`
          : response.data.data.descricaoPai
          ? `${response.data.data.descricaoPai} - ${response.data.data.descricao}`
          : response.data.data.descricao
      } catch (error) {
        if (error.message === 'Request failed with status code 404') {
          this.errorMessage('Insumo não encontrado')
          this.insumo = 'Insumo não encontrado'
        } else {
          this.errorMessage('Erro ao buscar insumo')
          this.insumo = 'Erro ao buscar insumo'
        }
      }
    },

    clear() {
      this.submit = false
      this.requisicao = {
        insumo: {},
        torre: null,
        andar: null,
        quantidade: '',
      }
      this.errors = {
        insumo: null,
        torre: null,
        andar: null,
        quantidade: null,
        quantidadeLimite: null,
      }
      this.codigoInsumo = ''
      this.insumo = ''
      this.requisicao.insumo = undefined
    },

    listLimits(item) {
      this.loading = true
      this.item = {}
      this.item = item
      this.quantityItems = []
      this.requisicao = {
        codigoInsumo: '',
        torre: null,
        andar: null,
        quantidade: '',
      }
      this.obraSelecionada = item
      this.modalOpenRegisters = !this.modalOpenRegisters
      this.obra = item
      this.andares = []
      item.andares.forEach((andar) => {
        const { nome, identificador } = andar
        this.andares.push({ text: nome, value: identificador })
      })
      
      serviceQuantidadeLimite
      .getQuantidadeLimite(this.obraSelecionada._id)
      .then(
          (response) => {
            this.quantityItems = response.data
          },
          (error) => {
            this.errorMessage(error.response.data.error.message)
          }
        ).finally(() => {
          this.loading = false
        })

      this.torres = []
      item.torres.forEach((torre) => {
        const { nome, identificador } = torre
        this.torres.push({ text: nome, value: identificador })
      })
    },
    handleRegister() {
      this.modalRegister = !this.modalRegister
      this.codigoInsumo = ''
      this.clear()
    },
    updateByFiliais() {
      this.listaObras()
    },
    async listaObras() {
      this.isLoading = true
      try {
        let {
          data: { data },
        } = await serviceObra.list(
          this.$store.state.filial ? 'filial' : null,
          this.$store.state.filial
        )
        this.obras = data
        this.rows = data.length
      } catch (_error) {
        this.errorMessage('erro ao listar')
      } finally {
        this.isLoading = false
      }
    },
    edit(item) {
      this.modalEdit = true
      this.itemEdit = JSON.parse(JSON.stringify(item))
    },
    clearEdit() {
      this.itemEdit = {}
    },
    modalDelete(item) {
      this.idDelete = item._id
      this.openModalDelete = true
    },
    cancelaDelete() {
      this.idDelete = ''
      this.openModalDelete = false
    },
  },
}
</script>

<style>
.class-row {
  cursor: pointer;
}

.header-button_register {
  display: flex;
  width: 100%;
  justify-content: flex-end;
  margin-bottom: 10px;
}

.obra-details {
  font-size: 14px;
  color: #999;
  margin-top: 5px;
  margin-bottom: 0;
  margin-left: 2px;
}

.row-buttons {
  display: flex;
  justify-content: space-between;
}

.icon-button {
  display: flex;
  padding: 2.5px;
  border-radius: 0.2rem;
  border: none;
  gap: 5px;
}

.icon-button i {
  margin: 0;
  height: 15px;
}

.footer-form {
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
}

.button-submit {
  margin-left: 10px;
}

.error {
  width: 100%;
  margin-top: 0.25rem;
  font-size: 80%;
  color: #ff5c75;
  font-family: 'Nunito Sans, sans-serif';
  font-weight: 200;
}
</style>